import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import envUrls from "../../utils/config";
import useProjects, {
  isWindPioneersUser,
  isWindPioneersProject,
} from "../../hooks/useProjects";
import DialogBox from "../../components/dialog/DialogBox";
import { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Mainnavbar from "../../components/mainNavbar/Mainnavbar";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { Link, NavLink, useHistory } from "react-router-dom";
import moment from "moment";
import {
  Card,
  Checkbox,
  MenuItem,
  Select,
  TablePagination,
} from "@material-ui/core";
import { ClassNames } from "@emotion/react";
import Details from "../../assets/Details.png";
import windlogo from "../../assets/Windbug.png";
import {
  Typography,
  DialogTitle,
  DialogContentText,
  DialogContent,
  Tooltip,
  Dialog,
  FormLabel,
  FormControlLabel,
  CircularProgress,
  RadioGroup,
  Radio,
  Box,
  TextField,
  TextareaAutosize,
  CardContent,
  CardActions,
  Button,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { toast } from "react-toastify";

// import DialogBox from '../../components/dialog/DialogBox';
import classes from "./issueTable.module.css";
import Navbar from "./navbar";
import Preview from "../previewPage/preview";
import UseTime from "../../hooks/useTime";
import { ExportToExcel } from "./exporttoexcel";
import AssignProductOwner from "../../utils/AssingnProductOwner";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

// axios defaults
axios.defaults.withCredentials = true;

const windvista_projects = [
  "WindVista",
  "WindVista_V2",
  "WindVistaReports",
  "Windexgraph",
  "Shear_V3",
  "Shear_V2",
  "Windoscope",
  "LTT",
];

// Description placeholders for Wind Pioneers tools
const BUG_DESCRIPTION_GUIDANCE =
  "Describe the issue\nWhat's already been done to investigate the problem?\n\nAdd any relevant links here (Loom Video Recorded Links, Project Folder on SP)";
const REQUEST_DESCRIPTION_GUIDANCE =
  "Describe the feature\nWhat would it solve? Has this been done before?\n\nAdd any relevant links here (Loom Video Recorded Links, File links on SP)";
const REQUEST_UPLOAD_HINT =
  "Upload mockups or any slide deck/document to explain your idea";

// Fallback Version / Sub-tool options plus Bug / Request guidance per project
// (keyed by lowercase name), used when list_projects doesn't return them in
// project_fields. Version is only asked for bugs, and sub-tool is only
// mandatory for bugs; a file is mandatory for bugs only.
const PROJECT_EXTRA_FIELDS = {
  windscribe: {
    versions: ["V3.2.2"],
    bug: {
      uploadHint:
        "Upload your WS3 file and any other relevant files/screenshots",
      descriptionPlaceholder: BUG_DESCRIPTION_GUIDANCE,
    },
    request: {
      uploadHint: REQUEST_UPLOAD_HINT,
      descriptionPlaceholder: REQUEST_DESCRIPTION_GUIDANCE,
    },
  },
  windwizz: {
    versions: ["V1"],
    subTools: [],
    bug: {
      uploadHint:
        "Please attach the 'windwizz_bug_report.zip' which contains a .log file and the user's config files",
      descriptionPlaceholder: BUG_DESCRIPTION_GUIDANCE,
    },
    request: {
      uploadHint: REQUEST_UPLOAD_HINT,
      descriptionPlaceholder: REQUEST_DESCRIPTION_GUIDANCE,
    },
  },
};

const getExtraFieldOptions = (selectedProject, issuetype, apiSubTools = []) => {
  const fields = (selectedProject && selectedProject.project_fields) || {};
  const projectName = (
    (selectedProject && selectedProject.project_name) ||
    ""
  ).toLowerCase();
  const fallback = PROJECT_EXTRA_FIELDS[projectName] || {};
  const isRequest = issuetype === "Request";
  const guidance = (isRequest ? fallback.request : fallback.bug) || {};
  const uploadHint = guidance.uploadHint || "";
  const subTools =
    projectName === "windscribe"
      ? apiSubTools.length > 0
        ? apiSubTools
        : fields.sub_tools || fields.sub_tool || []
      : fields.sub_tools || fields.sub_tool || fallback.subTools || [];
  return {
    versions: isRequest
      ? []
      : fields.versions || fields.version || fallback.versions || [],
    subTools,
    subToolRequired: !isRequest,
    uploadHint,
    fileRequired: !isRequest && !!uploadHint,
    descriptionPlaceholder: guidance.descriptionPlaceholder || "",
  };
};



// Red * shown next to mandatory fields in the Add Case form
const RequiredMark = () => <span style={{ color: "red" }}> *</span>;

// Standard error red for the messages under empty mandatory fields
const ERROR_COLOR = "#D32F2F";

// Red message under a mandatory field that was left empty on submit
const FieldError = ({ show, children = "This field is required" }) =>
  show ? (
    <small
      style={{
        display: "block",
        color: ERROR_COLOR,
        fontFamily: "Jost",
        margin: "-4px 10px 4px",
      }}
    >
      {children}
    </small>
  ) : null;

// Wraps a 350px-wide form field and shows the red * just outside its right
// edge, as in the mock-ups. `left` / `top` allow for the field's own margins.
const MarkedField = ({ required = true, left = 356, top = 0, children }) => (
  <div style={{ position: "relative" }}>
    {children}
    {required && (
      <span style={{ position: "absolute", left, top, color: "red" }}>*</span>
    )}
  </div>
);

function IssueTable() {
  const { projects, subTools: apiSubTools } = useProjects();
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [filteredData, setFilteredData] = useState();
  const [btnDisable, setBtnDisable] = useState(false);
  const [open, setOpen] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [isPasteActive, setIsPasteActive] = useState(false);
  const isZoneActive = isDragging || isPasteActive;
  const [excel, setexcel] = useState([]);
  const [title, setTitle] = useState("");
  const [level, setlevel] = useState("");
  const [instance, setInstance] = useState("Select");
  const [project, setProject] = useState("Select");
  const [priority, setPriority] = useState("");
  const [reportedon, setreportedon] = useState("");
  const [issuetype, setIssuetype] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");
  const [attachment, setAttachment] = useState([]);
  const [attachmentPreviewUrls, setAttachmentPreviewUrls] = useState([]);
  const [modalAttachment, setModalAttachment] = useState([]);
  const [modalAttachmentPreviewUrls, setModalAttachmentPreviewUrls] = useState([]);
  const [localPreviewUrl, setLocalPreviewUrl] = useState(null);
  const [valid, setvalid] = useState(true);
  const [projectUrl, setProjectUrl] = useState("");
  const [version, setVersion] = useState("Select");
  const [subTool, setSubTool] = useState("Select");

  const selectedProject = projects.find((p) => p.project_name === project);
  const {
    versions,
    subTools,
    subToolRequired,
    uploadHint,
    fileRequired,
    descriptionPlaceholder,
  } = getExtraFieldOptions(selectedProject, issuetype, apiSubTools);
  // WIND projects (WindScribe, WindWizz) don't use Instance or Priority;
  // the backend accepts them without these fields. Before a project is picked,
  // treat the form as WIND if every project this user can pick is WIND.
  const isWindProject = selectedProject
    ? selectedProject.project_type === "WIND"
    : projects.length > 0 && projects.every((p) => p.project_type === "WIND");

  // Mandatory fields that are still empty, with the name shown to the user.
  // Fields are only highlighted after the user has tried to submit.
  const [showErrors, setShowErrors] = useState(false);
  const missing = {
    issuetype: !issuetype && "Case type (Bug / Request)",
    project: project === "Select" && "Project",
    version: versions.length > 0 && version === "Select" && "Version",
    subTool:
      subTools.length > 0 && subToolRequired && subTool === "Select" &&
      "Sub-tool",
    projectUrl:
      windvista_projects.includes(project) && issuetype === "Bug" &&
      !projectUrl.trim() && "WindVista link",
    instance: !isWindProject && instance === "Select" && "Instance",
    title: !title.trim() && "Case title",
    description: !description.trim() && "Description",
    priority: !isWindProject && !priority && "Priority",
    file: fileRequired && attachment.length === 0 && "File",
  };
  const missingNames = Object.values(missing).filter(Boolean);
  const hasError = (key) => showErrors && !!missing[key];

  // const [a]
  const [issuecounts, setissuecounts] = useState({
    High: 0,
    Medium: 0,
    Low: 0,
  });

  function selectFewerProps(show) {
    const {
      issue_ID,
      issue_type,
      project_name,
      issue_title,
      instance,
      version,
      sub_tool,
      issue_stage,
      username,
      timestamp,
      priority,
      issue_status,
    } = show;
    return {
      issue_ID,
      issue_type,
      project_name,
      issue_title,
      instance,
      ...(isWindPioneersUser() ? { version, sub_tool } : {}),
      issue_stage,
      username,
      timestamp,
      priority,
      issue_status,
    };
  }
  // const newEpisodes = episodes.map(selectFewerProps);
  /*[
  {id: 1, title: "The One Where Ross Finds Out"},
  {id: 2, title: "The One With All the Resolutions"},
  {id: 3, title: "The One With The Cop"}
  ]*/
  let newfilteredData = filteredData?.map((val) => selectFewerProps(val));
  console.log(newfilteredData, "house was created");
  useEffect(() => {
    setexcel(newfilteredData);
  }, [filteredData]);

  console.log(title, instance, project, priority, status);
  toast.configure();
  console.log(issuecounts);

  const notifyValidationsError = (msg) =>
    toast(msg, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 5000,
    });
  const notifyValidationsWarns = (msg) => {
    toast.clearWaitingQueue();
    toast(msg, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 5000,
    });
  };

  const notifyValidationsSuccess = (msg) =>
    toast(msg, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 5000,
    });

  function setCookie(cname, cvalue, time) {
    var date = new Date();
    date.setTime(date.getTime() + time * 60 * 1000);
    var expires = "expires=" + date.toGMTString();
    var domain = window.location.hostname.endsWith("sirpi.co.in")
      ? ";domain=.sirpi.co.in"
      : "";
    document.cookie = cname + "=" + cvalue + ";" + expires + domain + ";";
  }

  function getCookie(name) {
    var found = document.cookie
      .split(";")
      .filter((c) => c.trim().split("=")[0] === name);
    return found.length > 0 ? found[0].split("=")[1].replace(/"/g, "") : null;
  }

  const handleLogout = (e) => {
    e.preventDefault();
    axios
      .get(envUrls.baseUrl + "logout")
      .then((res) => {
        setCookie("Authorization_windbug", "", 0);
        setCookie("email_windbug", "", 0);
        window.location.href = "/";
      })
      .catch((err) => {
        console.log(err);
        setCookie("Authorization_windbug", "", 0);
        setCookie("email_windbug", "", 0);
        window.location.href = "/";
      });
  };

  useEffect(() => {
    axios
      .get(envUrls.baseUrl + `all_issues?email=${getCookie("email_windbug")}`)
      .then((response) => {
        let data = response.data.data;
        // Wind Pioneers users see every issue; everyone else doesn't see
        // issues for the Wind Pioneers projects. The High / Medium / Low counts
        // always come from the backend.
        if (!isWindPioneersUser()) {
          data = data.filter(
            (item) => !isWindPioneersProject(item.project_name),
          );
        }
        setissuecounts(response.data.count);
        // setexcel(response.data.data)
        let sorted = data.sort(function (a, b) {
          return b.issue_ID - a.issue_ID;
        });

        console.log(response, "ider dekh");
        // setreportedon(response.data.system_date)
        // serial_no counts the cases this user can see, oldest = 1, with no
        // gaps (Case IDs skip the cases hidden from them). `sorted` is newest
        // first, so the newest case gets the highest number.
        let newData = sorted.map((item, index) => {
          const timestamp = UseTime(item.system_date);
          // console.log(timestamp);
          return {
            ...item,
            timestamp: timestamp,
            serial_no: sorted.length - index,
          };
        });
        newData.map((e, index) => {
          if (
            e.issue_status === "In Progress" ||
            e.issue_status === "" ||
            e.issue_status === "Open"
          ) {
            e.issue_status = "Open";
          }
          if (e.issue_status === "Close" || e.issue_status === "Closed") {
            e.issue_status = "Closed";
          }
        });
        newData.sort(function (a, b) {
          return b.id - a.id;
        });
        setRows(newData);
        setFilteredData(newData);
        setFilterStatus("All");
        // console.log(sorted, 'this is')
      })
      .catch((error) => {
        console.log(error);
        if (
          error.response.status == 401 &&
          sessionStorage.getItem("logging_out") !== "true"
        ) {
          window.location.href = "/login";
          notifyValidationsSuccess("Session expired, Please login again");
          sessionStorage.setItem("session_expired", "true");
        }
      });
  }, []);

  useEffect(() => {
    // console.log("rows",rows)
    if (
      filterStatus === "All" ||
      filterStatus === "Open" ||
      filterStatus === "Closed" ||
      filterStatus === "Reopen"
    ) {
      setFilteredData(
        filterStatus === "All"
          ? rows
          : rows.filter((dt) => dt.issue_status === filterStatus),
      );
    } else {
      setFilteredData(
        filterStatus === "All"
          ? rows
          : rows.filter((dt) => dt.priority === filterStatus),
      );
    }
    // console.log("setFilteredData",filteredData)
  }, [filterStatus]);

  const handleChangeForIssue = (event) => {
    setTitle(event.target.value);
  };
  const handleChangeForProject = (event) => {
    setProject(event.target.value);
    setVersion("Select");
    setSubTool("Select");
  };
  const handleChangeForPriority = (event) => {
    setPriority(event.target.value);
  };
  const handleChangeForIssuetype = (event) => {
    setIssuetype(event.target.value);
  };

  const handeleChangeForDesc = (event) => {
    let urlEncodedDescripition = encodeURIComponent(event.target.value);
    setDescription(urlEncodedDescripition);
  };

  const handleChangeForStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleChangeForInstance = (event) => {
    setInstance(event.target.value);
  };

  let fileTypeallowe = [
    "pdf",
    "jpg",
    "png",
    "docx",
    "jpeg",
    "ppt",
    "txt",
    "xls",
    "pptx",
    "xlsx",
    "xlsm",
    "ws3",
    "zip",
    "7z",
    "csv",
    "jam",
    "rtf",
    "tab",
    "kml",
    "kmz",
    "fig",
  ];
  const isAllowedFile = (f) =>
    fileTypeallowe.includes(f.name.toLowerCase().split(".").pop());
  const fileTypeError = "File Type not allowed";
  const handleFile = (event) => {
    const file = event.target.files;
    var fileLength = 0;
    if (modalAttachment && modalAttachment.length > 0) {
      fileLength = modalAttachment.length;
    }

    if (file.length > 0) {
      if (file.length + fileLength <= 4) {
        console.log("yes");
        console.log(file.length);
        // Keep only the allowed file types, whether one or several were picked
        const picked = Array.from(file);
        const allowed = picked.filter(isAllowedFile);
        if (allowed.length < picked.length) {
          notifyValidationsError(fileTypeError);
        }
        if (allowed.length > 0) {
          setModalAttachment((prev) => [...prev, ...allowed]);
        }
      } else {
        notifyValidationsError("Maximum 4 files can be uploaded");
      }
    }
    // Clear the picker so the same file can be chosen again after removing it
    event.target.value = "";
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (e) => {
    setOpen(false);
    setBtnDisable(false);
    // setBtnDisable(true)
    setTitle("");
    setProject("Select");
    setDescription("");
    setInstance("Select");
    setPriority("");
    setIssuetype("");
    setVersion("Select");
    setSubTool("Select");
    setAttachment([]);
    setModalAttachment([]);
    setShowErrors(false);
  };

  const handleAddIssue = async (fileKeys) => {
    if (attachment.length < 0) {
      setBtnDisable(true);
    }
    console.log(attachment);
    const email = getCookie("email_windbug").replace(/"/g, "");
    const timestamp = Date.now();

    const assignee = AssignProductOwner(project);

    if (missingNames.length > 0) {
      setShowErrors(true);
      notifyValidationsWarns("Please fill in the details");
      setBtnDisable(false);
      return;
    }

    const params = new URLSearchParams();
    params.append("timestamp", timestamp);
    params.append("issue_title", title);
    params.append("description", decodeURIComponent(description));
    if (!isWindProject) {
      params.append("instance", instance);
      params.append("priority", priority);
    }
    params.append("status", "");
    params.append("issueType", issuetype);
    params.append("project_name", project);
    params.append("email", decodeURIComponent(email));
    params.append("assignee", assignee);
    params.append("project_type", selectedProject?.project_type || "");
    if (versions.length > 0) {
      params.append("version", version);
    }
    if (subTools.length > 0 && subTool !== "Select") {
      params.append("sub_tool", subTool);
    }
 if (windvista_projects.includes(project) && issuetype === "Bug") {
  params.append("project_url", projectUrl);
}

    if (attachment.length > 0) {
      fileKeys.forEach((key) => {
        params.append("file_paths", key);
      });
    }

    const apiUrl = `${envUrls.baseUrl}add_issue?${params.toString()}`;

    try {
      const response = await axios.post(apiUrl);

      if (response.data.issue_id) {
        notifyValidationsSuccess("Case added successfully");
        setOpen(false);
        window.location.reload();
      } else {
        notifyValidationsWarns(response.data.error);
        setBtnDisable(false);
        setOpen(true);
      }
    } catch (err) {
      console.error("Error:", err.message);
      deleteFilesInS3(fileKeys);
      if (
        err.response?.status === 401 &&
        sessionStorage.getItem("logging_out") !== "true"
      ) {
        sessionStorage.setItem("session_expired", "true");
        window.location.href = "/login";
      }
    }
  };

  async function deleteFilesInS3(filePaths) {
    try {
      const params = new URLSearchParams();
      filePaths.forEach((path) => params.append("file_paths", path));
      const response = await axios.delete(
        `${envUrls.baseUrl}delete_files?${params.toString()}`,
      );
      if (response.status === 200) {
        console.log(response);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const openFileInput = () => {
    setIsDragging(false);
    setIsPasteActive(false);
    setModalAttachment([...attachment]);
    setShowUploadModal(true);
  };

  const closeUploadModal = () => {
    setShowUploadModal(false);
    setIsDragging(false);
    setIsPasteActive(false);
  };

  const handleConfirmAttach = () => {
    setAttachment([...modalAttachment]);
    closeUploadModal();
  };

  // Shared helper used by drag-drop and paste inside the upload modal
  const addFiles = (fileList) => {
    const incoming = Array.from(fileList);
    const currentCount = modalAttachment.length;
    if (currentCount >= 4) {
      notifyValidationsError("Maximum 4 files can be uploaded");
      return;
    }
    const slots = 4 - currentCount;
    const allowed = incoming.slice(0, slots).filter(isAllowedFile);
    const rejected = incoming.slice(0, slots).filter((f) => !isAllowedFile(f));
    if (rejected.length > 0) notifyValidationsError(fileTypeError);
    if (allowed.length > 0)
      setModalAttachment((prev) => [...prev, ...allowed]);
    if (incoming.length > slots)
      notifyValidationsError("Maximum 4 files can be uploaded");
  };

  const handleModalDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleModalDragLeave = () => setIsDragging(false);
  const handleModalDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    setIsPasteActive(false);
    addFiles(e.dataTransfer.files);
  };
  const handleModalPaste = (e) => {
    const clipboardData = e.clipboardData;
    if (!clipboardData) return;

    let incomingFiles = [];
    if (clipboardData.files && clipboardData.files.length > 0) {
      incomingFiles = Array.from(clipboardData.files);
    } else if (clipboardData.items && clipboardData.items.length > 0) {
      const fileItems = Array.from(clipboardData.items).filter(
        (it) => it.kind === "file"
      );
      incomingFiles = fileItems.map((it) => it.getAsFile()).filter(Boolean);
    }

    if (incomingFiles.length === 0) return;
    e.preventDefault();

    const normalizedFiles = incomingFiles.map((file) => {
      const ext =
        (file.type && file.type.split("/")[1]) ||
        file.name.split(".").pop() ||
        "png";
      const name =
        file.name && file.name !== "image.png" && file.name.trim() !== ""
          ? file.name
          : `screenshot-${Date.now()}.${ext}`;
      return new File([file], name, { type: file.type });
    });

    addFiles(normalizedFiles);
    setIsPasteActive(false);
  };

  let deletefileinput = (event, i) => {
    // incomplete for now
    console.log(i, attachment);
    setAttachment(attachment.filter((_, id) => id != i));
  };

  const deleteModalFileInput = (event, i) => {
    setModalAttachment((prev) => prev.filter((_, id) => id !== i));
  };

  useEffect(() => {
    const urls = modalAttachment.map((file) =>
      file.type && file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null
    );
    setModalAttachmentPreviewUrls(urls);
    return () => {
      urls.forEach((url) => url && URL.revokeObjectURL(url));
    };
  }, [modalAttachment]);

  useEffect(() => {
    const urls = attachment.map((file) =>
      file.type && file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null
    );
    setAttachmentPreviewUrls(urls);
    return () => {
      urls.forEach((url) => url && URL.revokeObjectURL(url));
    };
  }, [attachment]);

  const fileName = "CaseSheet";

  // s3 upload

  async function uploadFilesToS3() {
    const fileNames = attachment.map((file) => file.name);
    const email = getCookie("email_windbug");
    const timestamp = Date.now();
    const uploadType = "issue_file";

    const params = new URLSearchParams();

    fileNames.forEach((name) => params.append("file_names", name));
    params.append("email", email.replace(/"/g, ""));
    params.append("timestamp", timestamp);
    params.append("upload_type", uploadType);

    const url = `${envUrls.baseUrl}/get_presigned_urls?${params.toString()}`;
    try {
      const response = await axios.get(url);
      if (response.data) {
        console.log(response.data);
        const keys = [];
        const uploadPromises = response.data.map(async (data) => {
          const file = attachment.find((f) => f.name === data.file_name);
          if (!file) return;
          console.log(file);
          try {
            await axios.put(data.presigned_url, file, {
              headers: {
                "Content-Type": "application/octet-stream",
              },
              withCredentials: true,
            });
            console.log(`File uploaded: ${file.name}`);
            keys.push(data.key);
          } catch (uploadError) {
            console.error(`Error uploading file: ${file.name}`, uploadError);
            if (
              uploadError.response?.status === 401 &&
              sessionStorage.getItem("logging_out") !== "true"
            ) {
              sessionStorage.setItem("session_expired", "true");
              window.location.href = "/login";
            }
          }
        });

        await Promise.all(uploadPromises);

        if (keys.length === response.data.length) {
          handleAddIssue(keys);
          console.log(
            "All files uploaded successfully, proceeding to handleAddIssue.",
          );
        } else {
          console.warn(
            "Not all files were uploaded successfully. Skipping handleAddIssue.",
          );
        }
        console.log("All files uploaded successfully");
      }
    } catch (error) {
      console.error("Error getting presigned URLs:", error);
      notifyValidationsWarns(
        "Something went wrong while uploading the file(s)",
      );
      if (
        error.response?.status === 401 &&
        sessionStorage.getItem("logging_out") !== "true"
      ) {
        sessionStorage.setItem("session_expired", "true");
        window.location.href = "/login";
      }
    }
  }

  function handleSubmit(e) {
    setBtnDisable(true);
    e.preventDefault();
    // Check mandatory fields before uploading any files
    if (missingNames.length > 0) {
      setShowErrors(true);
      notifyValidationsWarns("Please fill in the details");
      setBtnDisable(false);
      return;
    }
    // Files may have been attached before the project was picked or changed
    if (!attachment.every(isAllowedFile)) {
      notifyValidationsWarns(
        fileTypeError + ". Please remove the other file(s).",
      );
      setBtnDisable(false);
      return;
    }
    if (attachment.length > 0) {
      uploadFilesToS3();
    } else {
      handleAddIssue();
    }
  }

  return (
    <div className={classes.box}>
      <Navbar></Navbar>
      <div className={classes.box2}>
        <Card elevation={6} className={classes.dashboard}>
          <h1 className={classes.dashboardTitle}>
            <img src={Details} style={{ marginTop: "-7px" }} /> Dashboard
          </h1>
          {/* <Button href='https://windbug.sirpi.co.in/issues' className={classes.backto} style={{ marginRight: '100px', height: '50px', marginTop: '20px' }}>Back to prod</Button> */}
          <div className={classes.small_box}>
            <div>
              <h3>{issuecounts.High}</h3>
              <p>High</p>
            </div>
            <div>
              <h3>{issuecounts.Medium}</h3>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#00000099",
                }}
              >
                Medium
              </p>
            </div>
            <div>
              <h3>{issuecounts.Low}</h3>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#00000099",
                }}
              >
                Low
              </p>
            </div>
          </div>
        </Card>

        <div className={classes.tab} style={{ clear: "both", padding: "0 20px" }}>
          <div
            className="table-scroll-wrapper"
            style={{
              width: "100%",
              margin: "20px auto",
              textAlign: "center",
            }}
          >
            <MaterialTable
              style={{
                textAlign: "center",
                border: "1px solid lightgray",
                width: "100%",
              }}
              icons={tableIcons}
              columns={[
                {
                  title: " Case ID",
                  field: "issue_ID",
                  width: "5%",
                  render: (rowData) => (
                    <NavLink
                      to={`/issue/${rowData.issue_ID}`}
                      style={{
                        color: "#004aad",
                        fontWeight: 600,
                        textDecoration: "underline",
                      }}
                    >
                      {rowData.issue_ID}
                    </NavLink>
                  ),
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                    paddingRight: "0px",
                  },
                },
                {
                  title: "Case Type",
                  field: "issue_type",
                  width: "2%",
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                    paddingRight: "0px",
                  },
                },
                {
                  title: "Project Name",
                  field: "project_name",
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                },

                {
                  title: "Case Title",
                  field: "issue_title",
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                    minWidth: "200px !important",
                  },
                  cellStyle: {
                    minWidth: "200px",
                  },
                },
                {
                  title: isWindPioneersUser() ? (
                    <span>
                      Instance/
                      <br />
                      Version
                    </span>
                  ) : (
                    "Instance"
                  ),
                  field: "instance",
                  render: (rowData) => {
                    const inst =
                      rowData.instance && !["NULL", "N/A"].includes(rowData.instance)
                        ? rowData.instance
                        : "";
                    const ver =
                      isWindPioneersUser() &&
                      rowData.version &&
                      !["NULL", "N/A"].includes(rowData.version)
                        ? rowData.version
                        : "";
                    return inst || ver || "—";
                  },
                  customFilterAndSearch: (term, rowData) => {
                    const val =
                      (rowData.instance && !["NULL", "N/A"].includes(rowData.instance)
                        ? rowData.instance
                        : "") ||
                      (isWindPioneersUser() &&
                      rowData.version &&
                      !["NULL", "N/A"].includes(rowData.version)
                        ? rowData.version
                        : "");
                    return val.toLowerCase().includes((term || "").toLowerCase());
                  },
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                },
                // Sub-tool only exists on WindScribe / WindWizz cases,
                // which only Wind Pioneers users can see
                ...(isWindPioneersUser()
                  ? [
                {
                  title: "Sub-tool",
                  field: "sub_tool",
                  render: (rowData) =>
                    rowData.sub_tool && !["NULL", "N/A"].includes(rowData.sub_tool) ? rowData.sub_tool : "—",
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                },
                  ]
                  : []),
                {
                  title: "Case level",
                  field: "issue_stage",
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                  cellStyle: {
                    width: "10px !important",
                    maxWidth: "22px ",
                  },
                },
                {
                  title: "Assigned to",
                  field: "assignee",
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                  cellStyle: {
                    // width: '100px',
                    minWidth: "150px",
                    maxWidth: "300px",
                    overflow: "hidden",
                  },
                },
                {
                  title: "Reported By",
                  field: "username",
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                  cellStyle: {
                    // width: '100px',
                    minWidth: "150px",
                    maxWidth: "300px",
                    overflow: "hidden",
                  },
                },
                {
                  title: "Reported Date",
                  field: "timestamp",
                  render: (rowData) => {
                    return (
                      <span style={{ fontSize: "14px" }}>
                        {rowData.timestamp}
                      </span>
                    );
                  },
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                  // cellStyle: {
                  //   minWidth: '140px'
                  // }
                },
                {
                  title: "Priority",
                  field: "priority",
                  render: (rowData) => {
                    if (!rowData.priority) return "—";
                    return rowData.priority === "Low" ? (
                      <p
                        style={{
                          backgroundColor: "#FEC400",
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "4px",
                          width: "100%",
                          fontSize: "14px",
                          padding: "0px 10px",
                          textAlign: "center",
                          marginBottom: "0px",
                        }}
                      >
                        {rowData.priority}
                      </p>
                    ) : rowData.priority === "Medium" ? (
                      <p
                        style={{
                          backgroundColor: "#FF8A00",
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "4px",
                          width: "100%",
                          fontSize: "14px",
                          padding: "0px 10px",
                          textAlign: "center",
                          marginBottom: "0px",
                        }}
                      >
                        {rowData.priority}
                      </p>
                    ) : (
                      <p
                        style={{
                          backgroundColor: "#FE0000",
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "4px",
                          width: "100%",
                          fontSize: "14px",
                          padding: "0px 10px",
                          textAlign: "center",
                          marginBottom: "0px",
                        }}
                      >
                        {rowData.priority}
                      </p>
                    );
                  },
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                },
                {
                  title: "Status",
                  field: "issue_status",
                  render: (rowData) => {
                    return rowData.issue_status === "Open" ? (
                      <p
                        style={{
                          backgroundColor: "green",
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "4px",
                          width: "100%",
                          fontSize: "14px",
                          padding: "0px 10px",
                          textAlign: "center",
                          marginBottom: "0px",
                        }}
                      >
                        {rowData.issue_status}
                      </p>
                    ) : rowData.issue_status === "Reopen" ? (
                      <p
                        style={{
                          backgroundColor: "skyblue",
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "4px",
                          width: "100%",
                          fontSize: "14px",
                          padding: "0px 10px",
                          textAlign: "center",
                          marginBottom: "0px",
                        }}
                      >
                        {rowData.issue_status}
                      </p>
                    ) : (
                      <p
                        style={{
                          backgroundColor: "#C4C4C4",
                          color: "white",
                          fontWeight: "bold",
                          borderRadius: "4px",
                          width: "100%",
                          fontSize: "14px",
                          padding: "0px 10px",
                          textAlign: "center",
                          marginBottom: "0px",
                        }}
                      >
                        {rowData.issue_status}
                      </p>
                    );
                  },
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                },
              ]}
              data={filteredData}
              title={"All Cases"}
              components={{
                // Keep the pagination inside the viewport instead of letting it
                // float off the right edge (where it was only reachable via a
                // horizontal scrollbar that some OS/browsers hide).
                Pagination: (props) => (
                  <TablePagination
                    {...props}
                    style={{
                      ...props.style,
                      float: "none",
                      overflowX: "visible",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  />
                ),
              }}
              actions={[
                {
                  icon: () => (
                    <Checkbox
                      checked={filter}
                      onChange={() => {
                        setFilter(!filter);
                      }}
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  ),
                  tooltip: "Hide / Show Filter Option",
                  isFreeAction: true,
                  headerStyle: {
                    border: "1px solid lightgray",
                    outline: "1px solid lightgray",
                  },
                },
                {
                  icon: () => (
                    <Select
                      style={{
                        border: "2px solid #C4C4C4",
                        boxSizing: "border-box",
                        borderRadius: "5px",
                        padding: "3px 5px",
                        width: "270px",
                        marginTop: "0px",
                        color: "#8B8B8B",
                        fontFamily: "Jost",
                        backgroundColor: "rgba(85, 80, 80, 0.068)",
                      }}
                      value={filterStatus}
                      onChange={(e) => {
                        setFilterStatus(e.target.value);
                      }}
                    >
                      <MenuItem value={"All"}>All Cases</MenuItem>
                      <MenuItem value={"Open"}>Open Cases</MenuItem>
                      <MenuItem value={"Closed"}>Closed Cases</MenuItem>
                      <MenuItem value={"Reopen"}>Reopen Cases</MenuItem>
                      <MenuItem value={"High"}>High Priority</MenuItem>
                      <MenuItem value={"Medium"}>Medium Priority</MenuItem>
                      <MenuItem value={"Low"}>Low Priority</MenuItem>
                    </Select>
                  ),
                  isFreeAction: true,
                },
                {
                  icon: () => {
                    return (
                      <div>
                        <button
                          className={classes.addissuebutton}
                          onClick={handleClickOpen}
                        >
                          <i className="fa fa-plus"></i> &nbsp;Add Case
                        </button>
                      </div>
                    );
                  },
                  isFreeAction: true,
                },
              ]}
              options={{
                actionsColumnIndex: -1,
                filtering: filter,
                pageSize: 5, // make initial page size
                pageSizeOptions: [5, 10, 20],
              }}
            />
            <ExportToExcel apiData={excel} fileName={fileName} />
          </div>
        </div>
      </div>
      <Dialog
        open={open}
        onClose={(_, reason) => { if (reason !== "backdropClick") handleClose(); }}
        PaperProps={{
          style: { borderRadius: "21px" },
        }}
      >
        <DialogTitle id="alert-dialog-title" style={{ paddingBottom: 0 }}>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                fontSize: "25px",
                fontWeight: "700",
                color: "#002960",
                fontFamily: "Poppins",
                marginLeft: "10px",
                lineHeight: 1.2,
              }}
            >
              Add Case
            </Typography>
            <Button
              onClick={handleClose}
              style={{ padding: "0px", marginRight: "-60px" }}
            >
              <i
                className="fa fa-times"
                style={{
                  color: "#ACACAC",
                  fontWeight: "400",
                  fontSize: "25px",
                }}
              ></i>
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box
              style={{ border: 2, display: "flex", flexDirection: "column" }}
            >
              <FormControl style={{ margin: 9 }}>
                <FormControl style={{ margin: 5 }}>
                  {/* <FormLabel id="demo-row-radio-buttons-group-label" style={{ color: '#8B8B8B', fontFamily: 'Jost' }}>Issue Type</FormLabel> */}
                  <RadioGroup
                    style={{ fontFamily: "Jost" }}
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    onChange={handleChangeForIssuetype}
                    value={issuetype}
                  >
                    <FormControlLabel
                      style={{ fontFamily: "Jost" }}
                      value="Bug"
                      control={
                        <Radio
                          color="success"
                          style={{ color: "red", fontFamily: "Jost" }}
                        />
                      }
                      label="Bug"
                    />
                    <FormControlLabel
                      style={{ fontFamily: "Jost" }}
                      value="Request"
                      control={
                        <Radio style={{ color: "green", fontFamily: "Jost" }} />
                      }
                      label="Request"
                    />
                    <RequiredMark />
                  </RadioGroup>
                  <FieldError show={hasError("issuetype")}>
                    Please select Bug or Request
                  </FieldError>
                </FormControl>

                <MarkedField>
                <Select
                  className={classes.input}
                  label="Project"
                  value={project}
                  onChange={handleChangeForProject}
                  style={{
                    border: "2px solid #C4C4C4",
                    boxSizing: "border-box",
                    borderRadius: "6px",
                    paddingLeft: "15px",
                    width: "350px",
                    marginTop: "0px",
                    fontFamily: "Jost",
                  }}
                >
                  <MenuItem hidden selected disabled value={"Select"}>
                    Select Project
                  </MenuItem>
                  {projects.map((item) => (
                    <MenuItem key={item.project_name} value={item.project_name}>
                      {item.project_name}
                    </MenuItem>
                  ))}
                </Select>
                </MarkedField>
                <FieldError show={hasError("project")} />
              </FormControl>

              {versions.length > 0 && (
                <FormControl style={{ margin: 9 }}>
                  <MarkedField top={5}>
                  <Select
                    label="Version"
                    value={version}
                    onChange={(e) => setVersion(e.target.value)}
                    style={{
                      border: "2px solid #C4C4C4",
                      boxSizing: "border-box",
                      borderRadius: "6px",
                      paddingLeft: "15px",
                      width: "350px",
                      marginTop: "5px",
                      fontFamily: "Jost",
                    }}
                  >
                    <MenuItem hidden selected disabled value={"Select"}>
                      Select Version
                    </MenuItem>
                    {versions.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                  </MarkedField>
                  <FieldError show={hasError("version")} />
                </FormControl>
              )}

              {subTools.length > 0 && (
                <FormControl style={{ margin: 9 }}>
                  <MarkedField top={5} required={subToolRequired}>
                  <Select
                    label="Sub-tool"
                    value={subTool}
                    onChange={(e) => setSubTool(e.target.value)}
                    style={{
                      border: "2px solid #C4C4C4",
                      boxSizing: "border-box",
                      borderRadius: "6px",
                      paddingLeft: "15px",
                      width: "350px",
                      marginTop: "5px",
                      fontFamily: "Jost",
                    }}
                  >
                    <MenuItem hidden selected disabled value={"Select"}>
                      Select sub-tool
                    </MenuItem>
                    {subTools.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                  </MarkedField>
                  <FieldError show={hasError("subTool")} />
                </FormControl>
              )}

              {windvista_projects.includes(project) && issuetype === "Bug" && (
  <Box
    sx={{
      margin: "9px",
      padding: "12px",
      border: "1px solid #E0E0E0",
      borderRadius: "10px",
      backgroundColor: "#F8FAFD",
    }}
  >
    <Typography
      variant="subtitle2"
      style={{
        color: "#002960",
        fontWeight: 600,
        marginBottom: "8px",
        fontFamily: "Jost",
      }}
    >
      Where did you face this issue?
      <RequiredMark />
    </Typography>

    <TextField
  fullWidth
  variant="outlined"
  size="small"
  placeholder="Insert WindVista Link/URL here"
  value={projectUrl}
  onChange={(e) => setProjectUrl(e.target.value)}
  FormHelperTextProps={{ style: { color: ERROR_COLOR } }}
  helperText={hasError("projectUrl") ? "This field is required" : ""}
  inputProps={{
    style: {
      fontSize: "13px",
      fontFamily: "Jost",
    },
  }}
/>
  </Box>
)}

              {!isWindProject && (
              <FormControl style={{ margin: 9 }}>
                <MarkedField top={5}>
                <Select
                  label="Instance"
                  value={instance}
                  onChange={handleChangeForInstance}
                  style={{
                    border: "2px solid #C4C4C4",
                    boxSizing: "border-box",
                    borderRadius: "6px",
                    paddingLeft: "15px",
                    width: "350px",
                    marginTop: "5px",
                    fontFamily: "Jost",
                  }}
                >
                  <MenuItem hidden selected disabled value={"Select"}>
                    Select Instance
                  </MenuItem>
                  <MenuItem value={"Production"}>Production</MenuItem>
                  <MenuItem value={"Beta"}>Beta</MenuItem>
                </Select>
                </MarkedField>
                <FieldError show={hasError("instance")} />
              </FormControl>
              )}
              {/* <TextField
                label="Issue Title"
                style={{ border: '2px solid #C4C4C4', borderRadius: '6px', paddingTop:'0px'}}
                onChange={handleChangeForIssue} /> */}

              <MarkedField left={365} top={15}>
                <input
                  type="text"
                  className="addissueinputfield"
                  onChange={handleChangeForIssue}
                  placeholder="Case Title"
                  style={{
                    margin: 9,
                    border: "2px solid #C4C4C4",
                    boxSizing: "border-box",
                    borderRadius: "6px",
                    paddingLeft: "15px",
                    width: "350px",
                    marginTop: "15px",
                    height: "34px",
                    fontFamily: "Jost",
                  }}
                />
              </MarkedField>
              <FieldError show={hasError("title")} />
              {/* <TextField
                id="outlined-multiline-flexible"
                label="Issue"
                multiline
                maxRows={4}
                style={{ margin: 9 }}
                onChange={handleChangeForIssue}

              /> */}

              <MarkedField left={365} top={20}>
                <TextareaAutosize
                  className="addissueinputfield"
                  placeholder={descriptionPlaceholder || "Description"}
                  minRows={descriptionPlaceholder ? 7 : 4}
                  fullWidth
                  maxRows={descriptionPlaceholder ? 7 : 4}
                  onChange={handeleChangeForDesc}
                  style={{
                    margin: 9,
                    border: "2px solid #C4C4C4",
                    boxSizing: "border-box",
                    borderRadius: "6px",
                    paddingLeft: "15px",
                    width: "350px",
                    marginTop: "20px",
                    color: "black",
                    fontFamily: "Jost",
                    fontSize: "14px",
                  }}
                />
              </MarkedField>
              <FieldError show={hasError("description")} />
              {/* {description === '' && <p style={{ color: 'red' }}>Enter valid Description</p>} */}
              {!isWindProject && (
              <FormControl style={{ margin: 9 }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  style={{ color: "black", fontFamily: "Jost" }}
                >
                  Priority
                  <RequiredMark />
                </FormLabel>
                <RadioGroup
                  style={{ color: "#8B8B8B", fontFamily: "Jost" }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  onChange={handleChangeForPriority}
                  value={priority}
                >
                  <FormControlLabel
                    style={{ color: "#8B8B8B", fontFamily: "Jost" }}
                    value="Low"
                    control={
                      <Radio style={{ color: "#8B8B8B", fontFamily: "Jost" }} />
                    }
                    label="Low"
                  />
                  <FormControlLabel
                    style={{ color: "#8B8B8B", fontFamily: "Jost" }}
                    value="Medium"
                    control={
                      <Radio style={{ color: "#8B8B8B", fontFamily: "Jost" }} />
                    }
                    label="Medium"
                  />
                  <FormControlLabel
                    style={{ color: "#8B8B8B", fontFamily: "Jost" }}
                    value="High"
                    control={
                      <Radio style={{ color: "#8B8B8B", fontFamily: "Jost" }} />
                    }
                    label="High"
                  />
                </RadioGroup>
                <FieldError show={hasError("priority")}>
                  Please select a priority
                </FieldError>
              </FormControl>
              )}

              {/* ── Upload Modal ── */}
              {showUploadModal && (
                <div
                  style={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 9999,
                    display: localPreviewUrl ? "none" : "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(0,0,0,0.45)",
                  }}

                >
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "16px",
                      padding: "32px 36px 28px",
                      width: "480px",
                      maxWidth: "95vw",
                      boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
                      fontFamily: "Jost, sans-serif",
                      position: "relative",
                    }}
                  >
                    {/* Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
                      <span style={{ fontSize: "1.15rem", fontWeight: 600, color: "#002960" }}>Attach File(s)</span>
                      <button
                        onClick={closeUploadModal}
                        style={{ background: "none", border: "none", fontSize: "1.4rem", cursor: "pointer", color: "#8B8B8B", lineHeight: 1 }}
                        title="Close"
                      >×</button>
                    </div>

                    {/* Drag & Drop / Paste zone */}
                    <div
                      tabIndex={0}
                      onClick={() => setIsPasteActive(true)}
                      onFocus={() => setIsPasteActive(true)}
                      onBlur={(e) => {
                        if (!e.currentTarget.contains(e.relatedTarget)) {
                          setIsPasteActive(false);
                        }
                      }}
                      onDragOver={handleModalDragOver}
                      onDragLeave={handleModalDragLeave}
                      onDrop={handleModalDrop}
                      onPaste={handleModalPaste}
                      style={{
                        border: `2px dashed ${isZoneActive ? "#1557B0" : "#C4C4C4"}`,
                        borderRadius: "12px",
                        background: isZoneActive ? "#EEF4FF" : "#FAFAFA",
                        padding: "36px 24px",
                        textAlign: "center",
                        cursor: "pointer",
                        outline: "none",
                        transition: "border-color 0.2s, background 0.2s",
                        marginBottom: 20,
                      }}
                    >
                      <i
                        className="fa fa-cloud-upload"
                        style={{
                          fontSize: "2.8rem",
                          color: isZoneActive ? "#1557B0" : "#C4C4C4",
                          marginBottom: 12,
                          display: "block",
                          transition: "color 0.2s",
                        }}
                      ></i>
                      <p
                        style={{
                          fontWeight: 600,
                          fontSize: "1rem",
                          color: isZoneActive ? "#002960" : "#333",
                          marginBottom: 6,
                          transition: "color 0.2s",
                        }}
                      >
                        Drag &amp; Drop or Paste your file here
                      </p>
                      <p
                        style={{
                          fontSize: "0.82rem",
                          color: isZoneActive ? "#1557B0" : "#8B8B8B",
                          marginBottom: 0,
                          transition: "color 0.2s",
                        }}
                      >
                        Drop files into this area &nbsp;·&nbsp; or press&nbsp;
                        <kbd
                          style={{
                            background: isZoneActive ? "#ffffff" : "#f0f0f0",
                            border: isZoneActive ? "1px solid #90caf9" : "none",
                            borderRadius: 4,
                            padding: "1px 5px",
                            fontSize: "0.78rem",
                            color: isZoneActive ? "#1557B0" : "inherit",
                          }}
                        >
                          Ctrl+V
                        </kbd>
                        &nbsp;/&nbsp;
                        <kbd
                          style={{
                            background: isZoneActive ? "#ffffff" : "#f0f0f0",
                            border: isZoneActive ? "1px solid #90caf9" : "none",
                            borderRadius: 4,
                            padding: "1px 5px",
                            fontSize: "0.78rem",
                            color: isZoneActive ? "#1557B0" : "inherit",
                          }}
                        >
                          Cmd+V
                        </kbd>
                        &nbsp;to paste a file or screenshot
                      </p>
                    </div>

                    {/* Divider */}
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
                      <div style={{ flex: 1, height: 1, background: "#E0E0E0" }} />
                      <span style={{ color: "#8B8B8B", fontSize: "0.82rem" }}>or</span>
                      <div style={{ flex: 1, height: 1, background: "#E0E0E0" }} />
                    </div>

                    {/* Browse button */}
                    <div style={{ textAlign: "center" }}>
                      <button
                        onClick={() => {
                          document.getElementById("fileupload").click();
                        }}
                        style={{
                          background: "linear-gradient(97.88deg, #002960 -4.13%, #1557B0 102.47%)",
                          color: "#fff",
                          border: "none",
                          borderRadius: "10px",
                          padding: "10px 32px",
                          fontFamily: "Jost",
                          fontSize: "0.95rem",
                          fontWeight: 600,
                          cursor: "pointer",
                          letterSpacing: "0.3px",
                        }}
                      >
                        <i className="fa fa-folder-open" style={{ marginRight: 8 }}></i>
                        Browse Files
                      </button>
                      <p style={{ marginTop: 10, fontSize: "0.76rem", color: "red", lineHeight: 1.45, maxWidth: "420px", margin: "10px auto 0" }}>
                        Max 4 files * &nbsp;·&nbsp; Allowed: pdf, jpg, jpeg, png, docx, ppt, pptx, xls, xlsx, xlsm, txt, csv, zip, 7z, ws3, jam, rtf, tab, kml, kmz, fig.
                      </p>
                    </div>

                    {/* ── Attached files list inside modal ── */}
                    {modalAttachment.length > 0 && (
                      <div
                        style={{
                          marginTop: 18,
                          paddingTop: 14,
                          borderTop: "1px solid #EAEAEA",
                          textAlign: "left",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 8,
                          }}
                        >
                          <span
                            style={{
                              fontSize: "0.85rem",
                              fontWeight: 600,
                              color: "#002960",
                            }}
                          >
                            Attached Files ({modalAttachment.length}/4):
                          </span>
                        </div>
                        <div
                          style={{
                            maxHeight: "130px",
                            overflowY: "auto",
                            paddingRight: 4,
                          }}
                        >
                          {Array.from(modalAttachment).map((elm, ind) => (
                            <div
                              key={ind}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                background: "#F8F9FA",
                                border: "1px solid #E9ECEF",
                                borderRadius: "8px",
                                padding: "6px 12px",
                                marginBottom: 6,
                                fontSize: "0.82rem",
                                color: "#333",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  marginRight: 10,
                                }}
                              >
                                <span
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                  title={elm.name}
                                >
                                  {ind + 1}. {elm.name}
                                </span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexShrink: 0,
                                }}
                              >
                                {modalAttachmentPreviewUrls[ind] && (
                                  <i
                                    className="fa fa-eye"
                                    title="Preview"
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                      color: "#1557B0",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      setLocalPreviewUrl(
                                        modalAttachmentPreviewUrls[ind]
                                      )
                                    }
                                  ></i>
                                )}
                                <i
                                  className="fa fa-trash text-danger"
                                  title="Delete"
                                  style={{
                                    fontSize: "16px",
                                    marginLeft: "12px",
                                    cursor: "pointer",
                                  }}
                                  onClick={deleteModalFileInput.bind(null, elm, ind)}
                                ></i>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div style={{ textAlign: "center", marginTop: 14 }}>
                          <button
                            onClick={handleConfirmAttach}
                            style={{
                              background: "#002960",
                              color: "#fff",
                              border: "none",
                              borderRadius: "8px",
                              padding: "8px 28px",
                              fontFamily: "Jost",
                              fontSize: "0.9rem",
                              fontWeight: 600,
                              cursor: "pointer",
                            }}
                          >
                            Attach
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* ── Choose File button ── */}
              <button
                className="btn text-left btn-outline-dark btn-sm"
                onClick={openFileInput}
                style={{
                  float: "left",
                  width: "150px",
                  marginLeft: 10,
                  marginBottom: 10,
                  borderRadius: "8px",
                  border: "2px solid #C4C4C4",
                  color: "#8B8B8B",
                  fontFamily: "Jost",
                }}
              >
                Choose File(s)
                {fileRequired && <RequiredMark />}
              </button>

              {/* ── Attached file list ── */}
              <div style={{ maxHeight: "50px", overflowY: "scroll" }}>
                {attachment.length > 0 &&
                  Array.from(attachment).map((elm, ind) => {
                    return (
                      <div
                        key={ind}
                        style={{
                          marginLeft: 10,
                          marginRight: 10,
                          color: "#8B8B8B",
                          fontFamily: "Jost",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: 6,
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span>
                            {ind + 1}. {elm.name}
                          </span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {attachmentPreviewUrls[ind] && (
                            <i
                              className="fa fa-eye"
                              style={{
                                fontSize: "18px",
                                marginLeft: "10px",
                                color: "#8B8B8B",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                setLocalPreviewUrl(attachmentPreviewUrls[ind])
                              }
                            ></i>
                          )}
                          <i
                            className="fa fa-trash text-danger"
                            style={{ fontSize: "18px", marginLeft: "10px" }}
                            onClick={deletefileinput.bind(null, elm, ind)}
                          ></i>
                        </div>
                      </div>
                    );
                  })}
              </div>
              {localPreviewUrl && (
                <Preview
                  open={true}
                  close={() => setLocalPreviewUrl(null)}
                  url={localPreviewUrl}
                />
              )}
              {
                // attachment.length === 0 ?
                //   <div style={{ marginLeft: 10, color: 'black', fontFamily: 'Jost' }}>
                //     <span>No File Chosen</span><br />
                //   </div> : ""
              }
              <input
                type="file"
                style={{ display: "none" }}
                id="fileupload"
                multiple={true}
                accept={undefined}
                onChange={handleFile}
              />
              {attachment.length === 0 && !uploadHint && (
                <small
                  style={{
                    marginLeft: "10px",
                    marginTop: 5,
                    color: "black",
                    fontFamily: "Jost",
                  }}
                >
                  Please upload input file(s) and screenshot
                </small>
              )}
              {attachment.length === 0 && uploadHint && (
                <small
                  style={{
                    display: "block",
                    maxWidth: "350px",
                    marginLeft: "10px",
                    marginTop: 5,
                    // Grey guidance until a submit without the required file
                    color: hasError("file") ? ERROR_COLOR : "#8B8B8B",
                    fontFamily: "Jost",
                  }}
                >
                  {uploadHint}
                </small>
              )}

              <button
                className={classes.butt}
                style={{
                  margin: 5,
                  padding: 5,
                  marginTop: "20px",
                  color: "white",
                  background:
                    "linear-gradient(97.88deg, #002960 -4.13%, #1557B0 102.47%)",
                  borderRadius: "12px",
                  fontSize: "1.4rem",
                  cursor: "pointer",
                }}
                variant="contained"
                color="success"
                onClick={handleSubmit}
                disabled={btnDisable}
              >
                Submit
                {btnDisable && (
                  <CircularProgress
                    style={{ color: "white", marginLeft: "5px" }}
                    size={20}
                  />
                )}
              </button>
            </Box>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default IssueTable;
